import { __awaiter, __generator } from "tslib";
import { networkRequest } from '@tencent/ark-request';
import { ApiError } from '../error/api-error';
import { ApiErrorCode } from '../error/api-error-code';
import { LoggerProxy } from '../logger/logger-proxy';
var AbstractDocumentDataFetcher = /** @class */ (function () {
    function AbstractDocumentDataFetcher() {
    }
    Object.defineProperty(AbstractDocumentDataFetcher.prototype, "fetchDocumentDataFromServer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (option, config) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, status, statusText;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(AbstractDocumentDataFetcher.tag, '从网络加载文档已落盘数据, option = ', option);
                            url = this.buildFetchDocumentDataURL(option, config);
                            return [4 /*yield*/, networkRequest.get(url)];
                        case 1:
                            response = _a.sent();
                            status = response.status, statusText = response.statusText;
                            if (response.status !== 200) {
                                throw new ApiError({
                                    code: ApiErrorCode.PrefetchDocumentDataError,
                                    subCode: -20001,
                                    message: "".concat(AbstractDocumentDataFetcher.tag, " \u4ECE\u7F51\u7EDC\u52A0\u8F7D\u6587\u6863\u5DF2\u843D\u76D8\u6570\u636E\u5F02\u5E38. url = ").concat(url, ", status = ").concat(status, ", statusText = ").concat(statusText, "."),
                                });
                            }
                            return [2 /*return*/, this.convertResponseToDocumentData(response.data, config)];
                    }
                });
            });
        }
    });
    /**
     * 本品类是否包含 chunk 数据块
     * PS: 如果本方法返回 true，需要实现 adapter 中对应的 chunkDataFetcher 对象
     * @returns 如果品类不需要拉取 chunk 数据块则返回 false， 反之返回 true
     * @default  false 默认为品类无 chunk 数据子块
     */
    Object.defineProperty(AbstractDocumentDataFetcher.prototype, "containChunkData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return false;
        }
    });
    Object.defineProperty(AbstractDocumentDataFetcher, "tag", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'AbstractDocumentDataFetcher'
    });
    return AbstractDocumentDataFetcher;
}());
export { AbstractDocumentDataFetcher };
